import apiCart from '@/api/member/cart';
import cartHelper from '@/helpers/cart';
import authHelper from '@/helpers/auth';

import apiTransaction from '@/api/member/transaction';

const defaultState = () => ({
	cartData: [],
	loadcart: false,
	detailCart: cartHelper.getCartData(),
	cartPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: '',
	saldoCoinGen: 0,
	saldoDepositReseller: 0,
});

const state = defaultState();

const getters = {
};

const mutations = {
	setSaldoDepositReseller(state, data) {
		state.saldoDepositReseller = data.data
	},
	setSaldoCoinGen(state, data) {
		state.saldoCoinGen = data.data
	},
	setCart(state, data) {
		state.cartData = data.data
		state.cartPagination = data.pagination;
	},
	setloadCart(state, data) {
		state.loadcart = data
	},
	setCartDetail(state, data) {
		cartHelper.setData(data)
		state.detailCart = cartHelper.getCartData()
	},
	removeCartDetail() {
		console.log("triggger")
		cartHelper.clearData()
		authHelper.clearRandomNumber()
		state.detailCart = cartHelper.getCartData()
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = {}
		for (const property in data) {
			state.responseError[property] = {
				message: data[property],
				show: true
			}
		}
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearCart(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getSaldoDepositReseller({ commit }, params) {
		commit('setloadCart', true);
		return new Promise((resolve) => {
			apiCart.getSaldoDepositReseller(params).then(({ data: data }) => {
				// console.log("saldocoinnn", data.data.saldo)
				commit('setSaldoDepositReseller', { data: data.data.saldo });
				resolve(true);
			}).catch(() => {
				commit('setSaldoDepositReseller', { data: 0 });
			}).then(() => {
				commit('setloadCart', false);
			});
		});
	},
	getSaldoCoinGen({ commit }, params) {
		commit('setloadCart', true);
		return new Promise((resolve) => {
			apiCart.getSaldoCoinGen(params).then(({ data: data }) => {
				// console.log("saldocoinnn", data.data.saldo)
				commit('setSaldoCoinGen', { data: data.data.saldo });
				resolve(true);
			}).catch(() => {
				commit('setSaldoCoinGen', { data: 0 });
			}).then(() => {
				commit('setloadCart', false);
			});
		});
	},
	getCart({ commit }, params) {
		commit('setloadCart', true);
		return new Promise((resolve) => {
			apiCart.getCart(params).then(({ data: { data } }) => {
				commit('setCart', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setCart', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadCart', false);
			});
		});
	},
	getCartDetail({ commit, dispatch }, params) {
		commit('setloadCart', true);
		return new Promise((resolve, reject) => {
			apiCart.getCartDetail(params).then(({ data: { data } }) => {
				commit('setCartDetail', data.results);
				resolve(true);
			}).catch((err) => {
				commit('setCartDetail', {});
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(data)
			}).then(() => {
				commit('setloadCart', false);
			});
		});
	},
	addItemCart({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiCart.addItemCart(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	updateItemCart({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiCart.updateItemCart(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	removeProductCart({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiCart.removeProductCart(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	async checkoutCart({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('setloadCart', true);
			await commit('progress', true, { root: true });
			await apiCart.checkoutCart(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
			await commit('setloadCart', false);
			await commit('progress', false, { root: true });
		});
	},
	async saveSnap({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('setloadCart', true);
			await apiCart.saveSnap(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
			await commit('setloadCart', false);
		});
	},
	async refundSaldoCoinGenFromMidtrans({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('setloadCart', true);
			await apiCart.refundSaldoCoinGenFromMidtrans(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
			await commit('setloadCart', false);
		});
	},
	async checkoutTrxFullCoinGen({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiTransaction.checkoutTrxFullCoinGen(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	async checkoutTrx({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiTransaction.checkoutTrx(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	async checkoutTrxStore({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiTransaction.checkoutTrxStore(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	async checkoutTrxVABCA({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiTransaction.checkoutTrxVABCA(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	success({ commit }, response) {
		commit('saveResponse', response)
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
				commit('validationError', response.data);
				break;

			case 'error_multiple_alert':
				commit('multipleAlert', response.data.error)
				break;

			default:
				commit('makeAlert', { code: response.code, type: 'error', message: response.message, show: true }, { root: true });
				break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};